import { render, staticRenderFns } from "./NotificationsCounter.vue?vue&type=template&id=882ef1b0&scoped=true"
import script from "./NotificationsCounter.vue?vue&type=script&lang=js"
export * from "./NotificationsCounter.vue?vue&type=script&lang=js"
import style0 from "./NotificationsCounter.vue?vue&type=style&index=0&id=882ef1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882ef1b0",
  null
  
)

export default component.exports